import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { FormattedDate } from 'react-intl';

import CustomIcon from '../../../DesignSystem/CustomIcon';
import { Icons } from '../../../../Themes';

function StatusChange({ content, createdAt }: any) {
  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ marginRight: 2 }}>
        <CustomIcon src={Icons.misc.changeCircle} color="secondary" />
      </Box>

      <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
        <span dangerouslySetInnerHTML={{ __html: content }} />
        <Box sx={{ margin: 1 }} component="span">
          •
        </Box>
        <FormattedDate value={createdAt} />
      </Typography>
    </Box>
  );
}

StatusChange.propTypes = {
  content: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
};

export default StatusChange;
